import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { SftpImportConfigurationWorkflow } from '../../../store/Models/Api/SftpImportModels';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { ColumnMappingDisplaySection } from '../sections/ColumnMappingDisplaySection';

interface ColumnMappingsPanelLocalProps {
    config: SftpImportConfigurationWorkflow;
}

type ColumnMappingsPanelProps = ColumnMappingsPanelLocalProps & ToxnotComponentProperties;

class ColumnMappingsPanelComponent extends ToxnotComponent<ColumnMappingsPanelProps> {
    render() {
        const { config } = this.props;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">{this.localizeString("Column Mappings")}</h3>
                </div>
                <div className="panel-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {config.spreadsheetHeadersToColumnIdMappings.length > 0 ? 
                        <ColumnMappingDisplaySection 
                            configData={config}
                            onConfigChange={() => {}} // Read-only, no changes allowed
                            isReadOnly={true}
                            showAddButton={false}
                        />
                        : <div className="alert alert-warning">
                            <p>{this.localizeString("No column mappings have been set.")}</p>
                          </div>
                    }
                </div>
            </div>
        );
    }
}

export const ColumnMappingsPanel = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ColumnMappingsPanelComponent);
